import { createContext, useEffect, useReducer } from 'react';
import { Auth } from 'aws-amplify';

const actionTypes = {
  INITIALIZE : 'INITIALIZE',
  SIGN_IN    : 'SIGN_IN',
  SIGN_OUT   : 'SIGN_OUT',
};

const initialState = {
  isInitialized   : false,
  isAuthenticated : false,
  user            : null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.INITIALIZE : {
      const { isAuthenticated, user } = action.payload;
      return { ...state, isInitialized: true, isAuthenticated, user };
    }
    case actionTypes.SIGN_IN    : {
      const { user } = action.payload;
      return { ...state, isAuthenticated: true, user };
    }
    case actionTypes.SIGN_OUT   : {
      return { ...state, isAuthenticated: false, user: null };
    }
    default: {
      throw new Error();
    }
  }
};

export const AuthContext = createContext({
  ...initialState,
  signIn  : () => Promise.resolve(),
  signOut : () => Promise.resolve(),
});

export const AuthProvider = (props) => {
  const { children } = props;
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const initialize = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        dispatch({ type: actionTypes.INITIALIZE, payload: { isAuthenticated: true, user } });
      } catch (error) {
        dispatch({ type: actionTypes.INITIALIZE, payload: { isAuthenticated: false, user: null } });
      }
    };

    initialize();
  }, []);

  const signIn = async (username, password) => {
    const user = await Auth.signIn(username, password);
    dispatch({ type: actionTypes.SIGN_IN, payload: { user } });
  };

  const signOut = async () => {
    await Auth.signOut({ global: true });
    dispatch({ type: actionTypes.SIGN_OUT });
  }

  return (
    <AuthContext.Provider value={{ ...state, signIn, signOut }}>
      {children}
    </AuthContext.Provider>
  );
};

export const AuthConsumer = AuthContext.Consumer;
